const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Main/SFP');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class SFP extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="99"
					width="match_parent"
					orientation="horizontal"
					padding="80,32,80,31"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<LinearLayout
						id={this.id("Group_5")}
						height="36"
						width="299"
						orientation="horizontal"
						style={this.style_Group_5}>
						<LinearLayout
							id={this.id("Juspay_Logo_V3")}
							height="34"
							width="152"
							orientation="horizontal"
							gravity="center"
							weight="1"
							style={this.style_Juspay_Logo_V3}>
							<ImageView
								id={this.id("Juspay_Logo_V3100000000ø")}
								height="34"
								width="match_parent"
								imageUrl="juspay_logo_v321"
								style={this.style_Juspay_Logo_V3100000000ø} />
						</LinearLayout>
						<ImageView
							id={this.id("University")}
							height="31"
							width="143"
							margin="4,5,0,0"
							imageUrl="university20"
							style={this.style_University} />
					</LinearLayout>
					<LinearLayout
						id={this.id("Space")}
						weight="1"
						style={this.style_Space} />
					<LinearLayout
						id={this.id("Group")}
						height="25"
						width="171"
						orientation="horizontal"
						margin="0,5,0,0"
						style={this.style_Group}>
						<TextView
							id={this.id("Register")}
							height="25"
							width="67"
							weight="1"
							text={this.STR.Register1}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Register} />
						<TextView
							id={this.id("Forum")}
							height="25"
							width="53"
							margin="51,0,0,0"
							text={this.STR.Forum2}
							textSize={FontSize.A_18}
							color={FontColor.A__FF3A3A3A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Forum} />
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("Wedliketosee")}
					height="678"
					width="1120"
					orientation="vertical"
					padding="300,0,0,0"
					margin="80,40,0,0"
					cornerRadius="0"
					style={this.style_Wedliketosee}>
					<TextView
						id={this.id("School_of_Functional")}
						height="130"
						width="800"
						text={this.STR.School_of_Functional14}
						textSize={FontSize.A_60}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="65px"
						gravity="left"
						style={this.style_School_of_Functional} />
					<ImageView
						id={this.id("Group_3_Copy")}
						height="387"
						width="308"
						margin="176,41,0,0"
						imageUrl="group3copy19"
						style={this.style_Group_3_Copy} />
					<TextView
						id={this.id("We_d_like_to_see_stu")}
						height="80"
						width="match_parent"
						margin="0,40,0,0"
						text={this.STR.We_d_like_to_see_stu15}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_We_d_like_to_see_stu} />
				</LinearLayout>
				<LinearLayout
					id={this.id("BgPrestoisan")}
					height="429"
					width="match_parent"
					orientation="horizontal"
					padding="80,0,75,0"
					margin="0,80,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_BgPrestoisan}>
					<LinearLayout
						id={this.id("Line2CourseB")}
						height="153"
						width="250"
						orientation="vertical"
						cornerRadius="0"
						style={this.style_Line2CourseB}>
						<LinearLayout
							id={this.id("Line_2")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="3,#ff0000"
							cornerRadius="0"
							style={this.style_Line_2} />
						<TextView
							id={this.id("Course")}
							height="50"
							width="171"
							margin="0,40,0,0"
							text={this.STR.Course16}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Course} />
						<LinearLayout
							id={this.id("Takethecours")}
							height="31"
							width="220"
							orientation="horizontal"
							margin="0,30,0,0"
							cornerRadius="0"
							style={this.style_Takethecours}>
							<ImageView
								id={this.id("Group_7")}
								height="31"
								width="30"
								imageUrl="group718"
								style={this.style_Group_7} />
							<TextView
								id={this.id("Take_the_course")}
								height="30"
								width="180"
								margin="10,1,0,0"
								weight="1"
								text={this.STR.Take_the_course17}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Take_the_course} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Prestoisanap")}
						height="377"
						width="825"
						orientation="vertical"
						padding="0,0,5,0"
						margin="50,52,0,0"
						weight="1"
						cornerRadius="0"
						style={this.style_Prestoisanap}>
						<TextView
							id={this.id("The_course_provides")}
							height="30"
							width="800"
							text={this.STR.The_course_provides18}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_The_course_provides} />
						<TextView
							id={this.id("Basics_of_Functional")}
							height="50"
							width="729"
							margin="0,15,0,0"
							text={this.STR.Basics_of_Functional19}
							textSize={FontSize.A_30}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_HEAVY}
							lineHeight="42px"
							gravity="left"
							style={this.style_Basics_of_Functional} />
						<TextView
							id={this.id("A_simplified_path_to")}
							height="60"
							width="match_parent"
							margin="0,7,0,0"
							text={this.STR.A_simplified_path_to20}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_A_simplified_path_to} />
						<TextView
							id={this.id("Presto_")}
							height="50"
							width="660"
							margin="0,30,0,0"
							text={this.STR.Presto_21}
							textSize={FontSize.A_30}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_HEAVY}
							lineHeight="42px"
							gravity="left"
							style={this.style_Presto_} />
						<TextView
							id={this.id("Presto_is_an_app_dev")}
							height="90"
							width="match_parent"
							margin="0,5,0,0"
							text={this.STR.Presto_is_an_app_dev22}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Presto_is_an_app_dev} />
						<TextView
							id={this.id("What_is_Presto_")}
							height="30"
							width="164"
							margin="0,10,0,0"
							text={this.STR.What_is_Presto_23}
							textSize={FontSize.A_22}
							color={FontColor.A__FFFF0000}
							fontStyle={Font.AVENIR_HEAVY}
							gravity="left"
							style={this.style_What_is_Presto_} />
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("BgGroup10Kno")}
					height="152"
					width="match_parent"
					orientation="horizontal"
					padding="80,0,94,0"
					margin="0,60,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_BgGroup10Kno}>
					<LinearLayout
						id={this.id("Group10Knowm")}
						height="142"
						width="250"
						orientation="vertical"
						cornerRadius="0"
						style={this.style_Group10Knowm}>
						<LinearLayout
							id={this.id("Line_2200000000ø")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="3,#ff0000"
							cornerRadius="0"
							style={this.style_Line_2200000000ø} />
						<TextView
							id={this.id("Internship")}
							height="50"
							width="230"
							margin="0,30,0,0"
							text={this.STR.Internship24}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Internship} />
						<LinearLayout
							id={this.id("KnowmoreGroup10")}
							height="30"
							width="190"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_KnowmoreGroup10}>
							<ImageView
								id={this.id("Group_10")}
								height="30"
								width="30"
								imageUrl="group1017"
								style={this.style_Group_10} />
							<TextView
								id={this.id("Know_more")}
								height="30"
								width="150"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.Know_more25}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Know_more} />
						</LinearLayout>
					</LinearLayout>
					<LinearLayout
						id={this.id("Learnthebasi")}
						height="110"
						width="806"
						orientation="vertical"
						margin="50,42,0,0"
						weight="1"
						cornerRadius="0"
						style={this.style_Learnthebasi}>
						<TextView
							id={this.id("Learn_the_basics_of")}
							height="30"
							width="match_parent"
							text={this.STR.Learn_the_basics_of26}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Learn_the_basics_of} />
						<TextView
							id={this.id("Learn_Presto")}
							height="30"
							width="107"
							margin="0,10,0,0"
							text={this.STR.Learn_Presto27}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							lineHeight="28px"
							gravity="left"
							style={this.style_Learn_Presto} />
						<TextView
							id={this.id("Apply_for_an_interns")}
							height="30"
							width="266"
							margin="0,10,0,0"
							text={this.STR.Apply_for_an_interns28}
							textSize={FontSize.A_18}
							color={FontColor.A__FF4A494A}
							fontStyle={Font.AVENIR_ROMAN}
							gravity="left"
							style={this.style_Apply_for_an_interns} />
					</LinearLayout>
				</LinearLayout>
				<LinearLayout
					id={this.id("Rectangle_2")}
					height="40"
					width="343"
					background={Color.A__FFFFFFFF}
					margin="469,22,0,0"
					cornerRadius="0"
					style={this.style_Rectangle_2} />
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = SFP;



// WEBPACK FOOTER //
// ./views/Main/SFP.js